import Compressor from "compressorjs";

interface CompressorConfig {
  quality?: number;
  maxWidth?: number;
  maxHeight?: number;
}

export default function compressorFile(
  file: File | Blob,
  config?: CompressorConfig
): Promise<File> {
  const size = file.size / 1024 / 1024;
  let quality = 0.9;
  if (size > 1) {
    quality = 0.8;
  }

  let maxWidth = 2048,
    maxHeight = 2048;

  if (config && config.quality) {
    quality = config.quality;
  }
  if (config && config.maxWidth) {
    maxWidth = config.maxWidth;
  }
  if (config && config.maxHeight) {
    maxHeight = config.maxHeight;
  }

  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: quality,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      success(result) {
        resolve(result as File);
      },
      error(err) {
        reject(err);
      },
    });
  });
}
